import { isValidLatitude, isValidLongitude, MaterialIcon } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { STREAMING_TIMEZONE_COLORS } from '../../../constants/streaming';
import { useStyles } from '../../../hooks/useStyles';
import { playbackStreamingMarkerTimezone, timelineIntermediatePositionState } from '../../../storage/streaming';

function CapturingTimelineMarker() {
  const marker = useRecoilValue(timelineIntermediatePositionState);
  const timezone = useRecoilValue(playbackStreamingMarkerTimezone);
  const { css, theme } = useStyles();
  const iconWrapper = css({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: 0,
    background: STREAMING_TIMEZONE_COLORS[timezone],
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    boxSizing: 'border-box',
    padding: theme.sizing.scale200,
    transition: 'background-color 200ms ease-in-out',
  });

  if (!marker || !marker.lat || !isValidLatitude(marker.lat) || !marker.lng || !isValidLongitude(marker.lng)) {
    return null;
  }

  const { lat: latitude, lng: longitude } = marker;

  return (
    <Marker
      longitude={longitude}
      latitude={latitude}
      rotation={0}
    >
      <span className={iconWrapper}>
        <MaterialIcon
          name={'place'}
          size={'18px'}
          color={theme.colors.contentInversePrimary}
        />
      </span>
    </Marker>
  );
}

export default memo(CapturingTimelineMarker);
